// Module
var code = "<p>The memo key is where you receive memos, in order to decode the memos you need to control the private key for the public key.</p> <p>By using a public/private key pair without spending authority, you may give read-only access to your memos to third parties.</p> ";
// Exports
export default code;